import React, {useEffect, useMemo, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import ManagerService from "../../../services/ManagerService";
import CssBaseline from "@material-ui/core/CssBaseline";
import EnhancedTable from "./managersTableComponent/EnhancedTable";
import {toast, ToastContainer} from "react-toastify";
import Spinner from "reactjs-simple-spinner";


const Managers = (props) => {
    const [activateLoading, setActivateLoading] = useState(false);
    const [deactivateLoading, setDeactivateLoading] = useState(false);

    const columns = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Surname',
                accessor: 'surname',
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Contact',
                accessor: 'contact_number',
            },
            {
                Header: 'Branch',
                accessor: 'branch'
            },
            {
                Header: 'Action',
                accessor: 'id',
                Cell: ({row, value}) => (
                    <span>
                        <Link className="btn btn-primary btn-sm " onClick={() => openEditForm(value)}>
                            Edit <i className="fa fa-edit"/>
                        </Link>
                        {row.original.status == '1' ? (
                            <Link className="btn btn-sm btn-danger " onClick={() => deactivate(value)}>
                                Deactivate &nbsp;<i className="fa fa-power-off"/>
                            </Link>

                        ) : (
                            <Link className="btn btn-sm btn-success " onClick={() => activate(value)}>
                                Activate &nbsp;<i className="fa fa-check-circle"/>
                            </Link>
                        )}

                    </span>

                )
            },
        ],
        []
    )

    //open edit form
    const openEditForm = (value) => {
        //store row record into localStorage
        localStorage.setItem('managerId',JSON.stringify(value));
        props.history.push('/edit-manager');
    }


    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)

    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    const [loading, setLoading] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        let token = JSON.parse(localStorage.getItem('token'));

        console.log("token", token)
        ManagerService.getAllManagers().then(response => {
            console.log(response.data);
            if (response.status === 200) {
                setData(response.data.managers);
                setLoading(false);
            } else {
                setData([])
                setLoading(false);
            }
        }).catch(err => {
            console.log(err);
            setData([])
            setLoading(false);
            toast.warning('Operation Failed, Reload Page\nIf error persists contact System Administrator ')
        });

    }, []);

    const activate = (id) => {
        setActivateLoading(true);
        //call activate endpoint
        ManagerService.activate(parseInt(id))
            .then(response => {
                console.log(response)
                toast(' User Activated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                ManagerService.getAllManagers().then(response => {
                    console.log(response.data.managers);
                    setData(response.data.managers);
                    setActivateLoading(false)
                }).catch(err => {
                    console.log(err);
                });
                setActivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                 toast.warning('Operation failed: ' + err, {
                     position: "top-center",
                     autoClose: 5000,
                     hideProgressBar: false,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                 });
                setActivateLoading(false);
            })

    }

    const deactivate = (id) => {
        setDeactivateLoading(true)
        //call deactivate endpoint
        ManagerService.deactivate(parseInt(id))
            .then(res => {
                console.log(res);
                toast(' Manager Deactivated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                ManagerService.getAllManagers().then(response => {
                    console.log(response.data.managers);
                    setData(response.data.managers);
                    setDeactivateLoading(false)
                }).catch(err => {
                    console.log(err);
                });
                setDeactivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation failed: ' + err, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setDeactivateLoading(false)
            })
    }


    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            {loading && (
                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                    <Spinner
                        size="large"
                        message="Loading Managers..."
                        line-fg-color="#64c3c2"
                    />
                </div>
            )}
            {!loading && (
                <div id="main-content" className="main-panel ps-container ps-theme-default">
                  <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                    <div className="content">
                        <div className="container-fluid">
                            <ul className="breadcrumb">
                                <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                                &nbsp;|&nbsp;
                                <Link to="/agents"><a href><i className="fa fa-user-circle"/>&nbsp;Sales Army</a></Link>
                                &nbsp;|&nbsp;
                                Managers
                            </ul>
                            <div className="row mt">
                                <div className="card col-lg-12">
                                    <div className="content-panel bg-white">
                                        <div id="table">
                                            {/*managers table*/}
                                            <CssBaseline/>
                                            <EnhancedTable
                                                columns={columns}
                                                data={data}
                                                setData={setData}
                                                updateMyData={updateMyData}
                                                skipPageReset={skipPageReset}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Managers;
